/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilityorganizationdescription2Inputs */

const zh_share_visibilityorganizationdescription2 = /** @type {(inputs: Share_Visibilityorganizationdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织成员可访问`)
};

const en_share_visibilityorganizationdescription2 = /** @type {(inputs: Share_Visibilityorganizationdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members of your organization can access`)
};

const es_share_visibilityorganizationdescription2 = /** @type {(inputs: Share_Visibilityorganizationdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los miembros de tu organización pueden acceder`)
};

/**
* | output |
* | --- |
* | "Members of your organization can access" |
*
* @param {Share_Visibilityorganizationdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilityorganizationdescription2 = /** @type {((inputs?: Share_Visibilityorganizationdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilityorganizationdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilityorganizationdescription2(inputs)
	if (locale === "en") return en_share_visibilityorganizationdescription2(inputs)
	return es_share_visibilityorganizationdescription2(inputs)
});
export { share_visibilityorganizationdescription2 as "share_visibilityOrganizationDescription" }